import Resource from '@/plugins/sdk/Resource'
import { BOOLEAN, DATETIME, STRING, UUID, ITEM, COLLECTION } from '@/plugins/sdk/fields'
import Level from '@/plugins/sdk/resources/Level'
import Account from '@/plugins/sdk/resources/Account'
import Team from '@/plugins/sdk/resources/Team'
import Permission from '@/plugins/sdk/resources/Permission'

export default class extends Resource {
  static name = 'role'

  static get fields () {
    return {
      id: new UUID(),
      name: new STRING(),
      description: new STRING(),
      deleted: new BOOLEAN(),
      deleted_date: new DATETIME(),
      level: new ITEM(Level),
      account: new ITEM(Account),
      teams: new COLLECTION(Team),
      permissions: new COLLECTION(Permission)
    }
  }
}
